import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-delta-filter',
  templateUrl: './delta-filter.component.html',
  styleUrls: ['./delta-filter.component.scss']
})
export class DeltaFilterComponent extends FilterAbstractModel implements OnInit, OnChanges {

  @Input() deltaFilterSelected: number;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.deltaFilterSelected)
      this.optionSelected = "" + this.deltaFilterSelected;
  }

  ngOnChanges() {
    if (this.deltaFilterSelected) {
      this.optionSelected = this.deltaFilterSelected;
    }
  }

  reset() {
    this.optionSelected = null;
  }

}
